<script>
    import { state, res, prefs, ui } from './stores.js';
    import { backupChoice, convert, pushChoice, restoreChoice, skipForManualAction, withTurnHeld } from './ui.js';
    import { doAction, updateState } from './game.js';
    import Breakdown from './Breakdown.svelte';
    import { committed } from './manual.js';


    export let status;
    export let m;

    // Held so a skipped prompt can't move the turn on before the action resolves
    function fireCardAction(e, type){
        return withTurnHeld(() => fireCardActionNow(e, type));
    }

    async function fireCardActionNow(e, type){
        let player = $state.players[$ui.seat];
        $ui.selection = false;
        await skipForManualAction();
        let savedHints = $prefs.showHints;
        let forceManual = e.shiftKey;
        if(forceManual){
            prefs.update(p => {
                p.showHints = false;
                return p;
            })
        }
        console.log('firing card action: resetting cache');
        state.update(s => {
            s.cache = {
                allPrev: [],
            };
            delete s.payingCost;
            return s;
        })
        let backup = backupChoice();
        pushChoice({
            fca: m.uniqueID,
            p: player,
            //cn: $ui.waiting.length > 0 ? $ui.waiting[0].choiceNum : 0,
            type
        })
        let result = await doAction(player, type, {card: m.uniqueID, obj: m.uniqueID});
        console.log('fca completed: result', result)
        if(result == 'cancelled'){
            restoreChoice(backup);
            updateState();
        }

        if(forceManual){
            $prefs.showHints = savedHints;
        }
        
    }



    //console.log(checkMission(p, m))
    
    //console.log(m, $res.parsedCardText[m.id]);

</script>
{#if committed(m).length > 0}
    <Breakdown cards={committed(m)} name="Cards here" />
{/if}
{#if status.ticked}
    <b style="color: lightgreen;">{m.name} (completed)</b>
{:else}
    <b>{m.name} ({status.percent}% complete)</b>
    {#if !status.unparsed}
        <ul>
            {#each status.elements as g}
                <li>
                    {@html convert(g.text, true)}:
                    {#if g.met}
                        ✅
                    {:else}
                        {g.count} of {g.total}, {g.left} remaining ({Math.round(g.count / g.total * 100)}%)
                        {#if g.eachMissing} – requirement 'at least {g.eachMissing} of each' not met{/if}
                    {/if}
                </li>
            {/each}
        </ul>
    {:else}
        Mission not parsed yet: needs manual assessment
    {/if}
    {#if status.complete}
        <div>
            Ready to complete ✅
        </div>
        <div>
            <button on:click={e => {fireCardAction(e, 'complete')}}>Complete!</button>
        </div>
    {:else}
        <div class="progress_meter">
            {#each Array(status.count > 0 ? status.count : 0) as _}
                <div class="progress_done" style="filter:hue-rotate(-{(100-status.percent)/100*90}deg);" />
            {/each}
            {#each Array(status.left > 0 ? status.left : 0) as _}
                <div class="progress_not_done" />
            {/each}
        </div>
        <div style="text-align: center; margin-top: 1.5vmin;">
            <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => {fireCardAction(e, 'complete')}}>Complete manually</button>
            <button style="font-size: {$prefs.buttonScale * 1.5}vmin; margin: 5px;" on:click={e => {fireCardAction(e, 'mark_complete')}}>Mark as complete (no auto effects)</button>
        </div>
    {/if}
{/if}
<div style="width: 100%;"/>
<style>
.progress_meter {
    width: 100%;
    height: 1vmin;
    display: flex;
    flex-wrap: nowrap;
}

.progress_done {
    background-color: green;
    border: 1px solid black;
    width: 100%;
}

.progress_not_done {
    background-color: white;
    border: 1px solid black;
    width: 100%;
}

</style>